@if (logsService.detailItems && logsService.detailItems.length) {
  <span class='h3'>Eventi</span>
}
<mat-paginator
  [pageSizeOptions]="[5, 10, 20, 50, 100, 200]"
  showFirstLastButtons
  [length]="logsService.detailPaginationResponse && logsService.detailPaginationResponse.meta.total"
  [pageSize]="(logsService.detailPaginationResponse && logsService.detailPaginationResponse.meta.perPage) || logsService.detailPerPage"
  (page)="onPageChanged($event)">
</mat-paginator>
@for (log of logsService.detailItems; track log) {
  <mat-card class='mb-8'>
    <mat-card-content>
      <p>Date: {{log.created_at | date:'yyyy-MM-dd HH:mm:ss'}}</p>
      <p>Type: {{log.log_type}}</p>
      @if (log.user) {
        <p>
          Utente: {{log.user.name}}
          @if (log.user.role) {
            <span class='ml-4 secondary-text'>
              ({{log.user.role.name}})
            </span>
          }
        </p>
      }
      <p>Message: {{log.message}}</p>
      @if (log.extra) {
        <mat-accordion>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                Extra
              </mat-panel-title>
            </mat-expansion-panel-header>
            @if (!log.extra_json && log.extra) {
              <pre>{{ log.extra | json}}</pre>
            }
            @if (log.extra_json) {
              <pre>{{ log.extra_json | json}}</pre>
            }
          </mat-expansion-panel>
          @if (log.extra_json && log.extra_json.request) {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{'Richiesta' | translate}}
                </mat-panel-title>
              </mat-expansion-panel-header>
              @if (log.extra_json.request.url) {
                <p>
                  [{{log.extra_json.request.method || '-'}}]: {{log.extra_json.request.url}}
                </p>
              }
              @if (log.extra_json.request.ip) {
                <p>IP: {{log.extra_json.request.ip}}</p>
              }
              @if (log.extra_json.request.inputs) {
                <pre>{{ log.extra_json.request.inputs | json }}</pre>
              }
            </mat-expansion-panel>
          }
          @if (log.extra_json && (log.extra_json.trace || log.extra_json.exception)) {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Stack Trace
                </mat-panel-title>
              </mat-expansion-panel-header>
              @if (log.extra_json.exception) {
                <p>Exception: {{log.extra_json.exception.trace | json}}</p>
                @if (log.extra_json.exception.file) {
                  <p>
                    File: {{log.extra_json.exception.file}} @if (log.extra_json.exception.line) {
                    <span>({{log.extra_json.exception.line}})</span>
                  }
                </p>
              }
            }
            @if (log.extra_json.file) {
              <p>
                File: {{log.extra_json.file}} @if (log.extra_json.line) {
                <span>({{log.extra_json.line}})</span>
              }
            </p>
          }
          @if (log.extra_json.trace) {
            <pre>{{ log.extra_json.trace }}</pre>
          }
        </mat-expansion-panel>
      }
      @if (log.target_table) {
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              Target Record
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p>Table: {{log.target_table}}</p>
          <p>RecordId: {{log.target_id}}</p>
          <a [routerLink]='"/dataset/detail/" + log.target_table + "/" + log.target_id' >GO</a>
        </mat-expansion-panel>
      }
    </mat-accordion>
  }
</mat-card-content>
</mat-card>
}